<template>
  <vs-row vs-justify="center" id="organization-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12" class="w-75" style="margin-left: auto; margin-right: auto;">
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Harif.Name')"
                            v-model="name"
                            class="w-100 mb-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Harif.ID')"
                            v-model="harif_id"
                            class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>
            
              </vs-col>
            </vs-row>
            <br>
           
            <vs-row class="float-right m-4" >
                  <vs-button color="primary" @click="createOrganization">{{$t('Harif.UpdateButton')}}</vs-button>
            </vs-row>
      </vs-card>
    </vs-col>   
  </vs-row>
</template>

<script>
import { harifService } from "../../_services";


export default {
  name: "organization-box",
  data: () => ({
        title: "Create Harif gateway",
        name: '',
        harif_id: '',
        errors: {
          firstname: false,
          lastname: false,
          email: false,
          phone: false,
          photo: false
        },
  }),
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        title: title,
        text: text,
        color: type
      });
    },
    createOrganization(){
      this.$vs.loading({
        container: '#organization-box',
        scale: 0.6
      });

      try{
        let harif = new FormData();
        harif.append('name',this.name);
        harif.append('harif_id',this.harif_id);
        harifService.update(harif, this.$route.params.id).catch(function () {
        }.bind(this)).finally(function () {
            this.$vs.loading.close('#organization-box > .con-vs-loading');
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Harif.UpdateSuccess"),"success"
            );
            this.$router.push('/harif_sms_gateways')
          }.bind(this));
          } catch (e) {
              this.$vs.loading.close('#organization-box > .con-vs-loading');
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Harif.UpdateFail"),"danger");
            }
      },

  },
  mounted() {
      harifService.getById( this.$route.params.id ).then(function(data){
          this.harif_id= data.harif_gateway.harif_id;
          this.name= data.harif_gateway.name;
      }.bind(this))
  }
}
</script>

<style>

</style>